import { Spinner } from "../spinner";
import styles from "./styles.module.scss";

export const Loader = ({isWalky}) => {
  return (
    <div className={styles.loader}>
      <Spinner isWalky={isWalky}/>
    </div>
  );
};
